import { WhiteLabelState, WhiteLabelTheme } from './types';
import { GetterTree } from 'vuex';
import { RootState } from '../rootState';

export const getters: GetterTree<WhiteLabelState, RootState> = {
  getThemes(state): WhiteLabelTheme {
    return state.themes;
  }
};
